// Shared bits for the printable auction invoices (deposit top-up + won car),
// both styled on the official "შპს ქარ ექსპრესი" invoice template.

// Seller (fixed) — from the official template.
export const SELLER = {
    name: 'შპს „ქარ ექსპრესი“',
    idCode: "404910511",
    bank: "თიბისი ბანკი",
    iban: "GE65TB7738936080100003",
};

// A GEL amount as a plain number with thousands separators, rounded to a whole
// lari with no decimals (matching the site-wide rounded money display).
export const gelNum = (x) => Math.round(Number(x) || 0).toLocaleString("en-US");

// ── Georgian number → words (for the "amount in words" line) ─────────────────
const ONES = ["ნული", "ერთი", "ორი", "სამი", "ოთხი", "ხუთი", "ექვსი", "შვიდი", "რვა", "ცხრა",
    "ათი", "თერთმეტი", "თორმეტი", "ცამეტი", "თოთხმეტი", "თხუთმეტი", "თექვსმეტი", "ჩვიდმეტი", "თვრამეტი", "ცხრამეტი"];
const TENS_PREFIX = ["", "ოც", "ორმოც", "სამოც", "ოთხმოც"];       // 20,40,60,80 (base-20)
const HUND_STEM = ["", "ას", "ორას", "სამას", "ოთხას", "ხუთას", "ექვსას", "შვიდას", "რვაას", "ცხრაას"];

function below100(n) {
    if (n < 20) return ONES[n];
    const twenty = Math.floor(n / 20);
    const rem = n % 20;
    const prefix = TENS_PREFIX[twenty];
    return rem === 0 ? `${prefix}ი` : `${prefix}და${ONES[rem]}`;
}
function below1000(n) {
    if (n < 100) return below100(n);
    const h = Math.floor(n / 100);
    const rem = n % 100;
    return rem === 0 ? `${HUND_STEM[h]}ი` : `${HUND_STEM[h]}${below100(rem)}`;
}

/** Georgian words for a non-negative integer amount (lari), e.g. 6000 -> "ექვსი ათასი". */
export function geoWords(n) {
    const v = Math.max(0, Math.floor(Number(n) || 0));
    if (v === 0) return ONES[0];
    const th = Math.floor(v / 1000);
    const rem = v % 1000;
    if (th === 0) return below1000(rem);
    const thPart = th === 1 ? "ათას" : `${below1000(th)} ათას`;
    return rem === 0 ? `${thPart}ი` : `${thPart} ${below1000(rem)}`;
}
